import "./placeholderLoading.css";

export const Rectangle: React.FC = () => {
  return <div className="placeholder-rectangle" />;
};

export const Spin: React.FC = () => {
  return <div className="placeholder-spin" />;
};
